import { ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, Renderer2, ViewChild } from "@angular/core";
import * as Sentry from '@sentry/angular';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { Observable, Subscription } from "rxjs";
import { MediaMatcher } from "@angular/cdk/layout";
import { SwalNotificationService } from "src/app/features/shared/services/SwalNotification.service";
import { CustomerRole } from "../../models/CustomerRole";
import { UserService } from "../../services/Users.service";
import { SessionService } from "src/app/features/shared/services/Session.service";
import { environment } from "src/environments/environment";
@Component({
  selector: "users-add",
  templateUrl: "./users-add.component.html",
  styleUrls: ["./users-add.component.css"],
})
export class UsersAddComponent implements OnInit, OnDestroy {
  @ViewChild("password") btnPassword: ElementRef;

  public $otherCustomers: Observable<any>;

  public formGroup: FormGroup;
  otherCustomers: {
    selected: boolean,
    idCustomer: string, 
    customerName:string, 
    roles: CustomerRole[],
    groups: string[],
    identifiers: string[],
    subGroups: string[]
  }[];
  selectedCustomers: {
    selected: boolean,
    number: number, 
    idCustomer: string, 
    customerName:string, 
    roles: CustomerRole[],
    groups: string[],
    identifiers: string[],
    subGroups: string[]
  }[] = [];
  hidePassword = true;
  extraCustomerCount: number[] = [];
  readonly: boolean = true;
  _isVinsSelected: boolean;
  _stringIdentifiers: string ="";
  click = false;
  isLoading: boolean = false;

  subscription_getInsertUser: Subscription;
  subscription_postInsertUser: Subscription;
  subscription_getGroups: Subscription;
  subscription_otherCustomers: Subscription;

  mobileQuery: MediaQueryList;
  private _mobileQueryListener: () => void;

  constructor(
    private sessionService: SessionService,
    private renderer: Renderer2,
    private formBuilder: FormBuilder,
    private userService: UserService,
    private notifyService: SwalNotificationService,
    private routerService: Router,
    changeDetectorRef: ChangeDetectorRef, 
    media: MediaMatcher,
  ) {
    this.mobileQuery = media.matchMedia("(min-width: 1001px)");
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
    this._isVinsSelected = false;
    this.userService.isUpdateUser = false;
    this.$otherCustomers = this.userService.getOtherCustomers();
    this.subscription_otherCustomers = this.$otherCustomers.subscribe((data) => {
      this.otherCustomers = data;
    });
  }

  ngOnInit(): void {
    this.sessionService.setIsExternalMap(false);
    this.bulidForm();
    this.getInsertUsers();
    this.readonly = true;
  }
  ngOnDestroy() {
    if (this.subscription_getInsertUser) 
      this.subscription_getInsertUser.unsubscribe();
    if (this.subscription_postInsertUser) 
      this.subscription_postInsertUser.unsubscribe();
    if (this.subscription_getGroups) 
      this.subscription_getGroups.unsubscribe();
    if (this.subscription_otherCustomers) 
      this.subscription_otherCustomers.unsubscribe();
  }
  getInsertUsers() {
    this.subscription_getInsertUser = this.userService.getInsertUser().subscribe({
      next: (data) => {
        if (data.isSuccess) {
          if(!environment.production) console.log("get register user",data.result);
          this.otherCustomers = data.result.clientes;
          this.otherCustomers.forEach(customer => {customer.selected = false});
          this.userService.setOtherCustomers(this.otherCustomers);
          if(!environment.production) console.log('clientes',this.otherCustomers);
        }else{
          console.error('Error al obtener datos para insertar usuario', data.message);
          Sentry.captureMessage('UsersAdd.getInsertUsers: isSuccess false', { level: 'warning', extra: { response: data } });
        }
      },
      error: (error) => {
        // TODO marca para complete despues
        console.error('Error al obtener datos para insertar usuario', error);
      }
    });
  }

  
  bulidForm() {
    const myRegex = new RegExp('^(?=.*\\d)(?=.*[A-Z])(?=.*[#%$&?\/])[a-zA-Z0-9#\$&\?\/%]{8,15}$');
    const myRegexNombres = new RegExp('^[a-zA-Z .]+$');
    this.formGroup = this.formBuilder.group({
      client: ["", Validators.required],
      customers: [[]],
      firstName:  ["", Validators.compose([Validators.required]), Validators.pattern(myRegexNombres)],
      lastName:  ["", Validators.pattern(myRegexNombres)],
      secondLastName:  ["", Validators.pattern(myRegexNombres)],
      email: ["", Validators.compose([Validators.required,Validators.email])],
      password: ["", Validators.compose([Validators.pattern(myRegex)])],
      confirmPassword: ["", Validators.compose([Validators.pattern(myRegex)])],
      userNameCitronella: "",
      isUserAPP: false,
      rol: ["", Validators.required],
      identifiers: [],
      groups: [[]],
      subGroups: [[]]
    }, {
      validator: this.passwordMatchValidator
    });
  }

  public onSubmit(users: any) {
    this.isLoading = true;
    //se crea un objeto para no modificar el objeto original
    users.customers = this.otherCustomers;
    const submitUser = JSON.parse(JSON.stringify(users));

    // Asignar el cliente default en la posición 0
    submitUser.customers= [];
    submitUser.customers[0] = this.selectedCustomers.find(x => x.number === 0);

    // Filtrar los elementos distintos de 0 y agregarlos al array
    const otherSelectedCustomers = this.selectedCustomers.filter(x => x.number !== 0);
    otherSelectedCustomers.forEach(customer => {
      if (customer.selected) {
        submitUser.customers.push(customer); 
      }
    });
    if(!environment.production) console.log('users',submitUser);
    
    if (submitUser.identifiers != null){
      this.subscription_postInsertUser = this.userService.postInsertUser(submitUser).subscribe({
        next: (data) => {
          if (data.isSuccess) {
            this.notifyService.MessageSuccessful(
              "Usuario Creado Exitosamente",
              "El usuario fue registrado exitosamente"
            );
            this.isLoading = false;
            this.routerService.navigate(["/settingsAdmin"]);
          } else {
            // this.notifyService.MessageError(data.message);
            console.error('Error al insertar usuario', data.message);
            Sentry.captureMessage('UsersAdd.postInsertUser: isSuccess false', { level: 'warning', extra: { response: data } });
            this.isLoading = false;
          }
        },
        error: (error) => {
          // TODO marca para complete despues
          console.error('Error al insertar usuario', error);
          this.isLoading = false;
          this.notifyService.MessageError("Error al crear el usuario, contacte con el administrador");
        }
      });
    }else{
      this.isLoading = false;
    }
    
  }

  public onClickMostrarContrasena(){
    if(!this.click){
      this.renderer.setAttribute(this.btnPassword.nativeElement, "type","text");
      this.click = true
    }else if(this.click){
      this.renderer.setAttribute(this.btnPassword.nativeElement, "type","password");
      this.click = false
    }
  }

  public getError(controlName: string): string {
    let error = "";
    const control = this.formGroup.get(controlName);
    if (control?.touched && control?.errors != null) {
      if (control?.errors?.["required"]) error = "Campo Requerido *";
      else if (control?.errors?.["email"]) error = "Introduzca un email válido *";
      else if (control?.errors?.["minLength"]) error = "Minimo 8 digitos *";
      else if (control?.errors?.["passwordMismatch"]) error = "Las contraseñas no son iguales";
      else if (control?.errors?.["pattern"]) {
        if (controlName === "lastName" || controlName === "secondLastName" || controlName === "firstName") {
          control.setErrors({ pattern: true });
          error = "Solo se permiten caracteres alfabéticos.";
        } else if (controlName === "password") {
          control.setErrors({ pattern: true });
          error = "Requisitos:" +
            "Al menos un dígito (0-9)." +
            "Al menos una letra mayúscula (A-Z)." +
            "Al menos un símbolo permitido (#,$,&,?,/,%)." +
            "Letras minúsculas (a-z)." +
            "Entre 8 y 15 caracteres de longitud.";
        }
      }
      else error = JSON.stringify(control.errors);
    }
    return error;
  }

  assignCustomerData(customerData: any) {
    if(!environment.production) console.log('customerData',customerData, customerData.selected);
    //si el cliente es el default, agrega los datos default para que haya verrificación de campos
    if (customerData.number == 0) {
      //si el cliente default tiene la seleccion correcta, se añaden los datos al formulario, si no, se elimina
      if (customerData.selected) {
        this.formGroup.controls["client"].patchValue(this.otherCustomers.find(x => x.customerName == customerData.customerName).idCustomer);
        this.formGroup.controls["rol"].patchValue(customerData.roles[0].id);
        this.formGroup.controls["groups"].patchValue(customerData.groups);
        this.formGroup.controls["subGroups"].patchValue(customerData.subGroups);
        this.formGroup.controls["identifiers"].patchValue(customerData.identifiers);
        if(!environment.production) console.log('formGroup si',this.formGroup.value);
      }else{
        this.formGroup.controls["client"].patchValue("");
        this.formGroup.controls["rol"].patchValue("");
        this.formGroup.controls["groups"].patchValue("");
        this.formGroup.controls["subGroups"].patchValue("");
        this.formGroup.controls["identifiers"].patchValue("");
        if(!environment.production) console.log('formGroup no',this.formGroup.value);
      }
      
      //si el cliente seleccionado no se ha añadido a la selección, se añade, si ya existe, se modifica
      if (this.selectedCustomers.find(x => x.number == 0) == null) {
        this.selectedCustomers.push(customerData);
      }else{
        const selectedCustomerZero = this.selectedCustomers.find(x => x.number === 0);

        selectedCustomerZero.customerName = customerData.customerName;
        selectedCustomerZero.idCustomer = customerData.idCustomer;
        selectedCustomerZero.roles = customerData.roles;
        selectedCustomerZero.groups = customerData.groups;
        selectedCustomerZero.identifiers = customerData.identifiers;
        selectedCustomerZero.subGroups = customerData.subGroups;
        selectedCustomerZero.selected = customerData.selected;
      }
    }else{
      //si el cliente seleccionado no se ha añadido a la selección, se añade, si ya existe, se sobreescribe
      if (this.selectedCustomers.find(x => x.number == customerData.number) == null) {
        this.selectedCustomers.push(customerData);
      }else{
        const selectedCustomer = this.selectedCustomers.find(x => x.number == customerData.number);
        selectedCustomer.customerName = customerData.customerName;
        selectedCustomer.idCustomer = customerData.idCustomer;
        selectedCustomer.roles = customerData.roles;
        selectedCustomer.groups = customerData.groups;
        selectedCustomer.identifiers = customerData.identifiers;
        selectedCustomer.subGroups = customerData.subGroups;
        selectedCustomer.selected = customerData.selected;
      }
    }
    if(!environment.production) console.log('otherCustomers',this.otherCustomers, 'selectedCustomers',this.selectedCustomers);

  }

  readOnly(){
    this.readonly = false;
  }

  puedeAgregarCliente(): boolean {
    if (this.otherCustomers == undefined) return false;
    const totalFilas = 1 + this.extraCustomerCount.length;
    const hayClienteDisponible = this.otherCustomers.some(c => !c.selected);
    return totalFilas < this.otherCustomers.length && hayClienteDisponible;
  }

  agregarCliente(){
    if (this.puedeAgregarCliente()) {
      let index = 0;
      if (this.extraCustomerCount.length == 0) {
        index = 1;
      }else{
        index =  Math.max(...this.extraCustomerCount) + 1;
      }
      this.extraCustomerCount.push(index);
    }
  }

  quitarCliente(){
    if (this.extraCustomerCount.length > 0) {
      this.extraCustomerCount.splice(-1, 1);
    }
  }

  DeleteCustomerIndex(selectedNumber: number) {
    const index = this.extraCustomerCount.indexOf(selectedNumber);
    this.extraCustomerCount.splice(index, 1);
  }

  passwordMatchValidator(form: FormGroup) {
    const passwordControl = form.get('password');
    const confirmPasswordControl = form.get('confirmPassword');

    if (passwordControl.value !== confirmPasswordControl.value) {
      confirmPasswordControl.setErrors({ passwordMismatch: true });
    } else {
      confirmPasswordControl.setErrors(null);
    }
  }

}
